'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.loyalty = void 0;
var adapter_1 = require("../adapter");
var util_1 = require("../util");
var Loyalty = /** @class */ (function () {
    function Loyalty() {
    }
    Loyalty.prototype.userProgress = function (params) {
        return adapter_1.adapter.loyalty.userProgress(params);
    };
    Loyalty.prototype.history = function () {
        return adapter_1.adapter.loyalty.history();
    };
    Loyalty.prototype.rank = function (params) {
        return adapter_1.adapter.loyalty.rank(params).then(util_1.normalize);
    };
    return Loyalty;
}());
exports.loyalty = new Loyalty();
